import React from "react";
import { X, UtensilsCrossed, ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function MobileMenu({
  isOpen,
  onClose,
  onNavigate,
  LanguageSelection,
}) {
  return (
    <div
      className={`fixed inset-0 z-[100] flex justify-end transition-all duration-500 ${
        isOpen ? "pointer-events-auto" : "pointer-events-none"
      }`}
    >
      <MobileMenuContent isOpen={isOpen} onClose={onClose} onNavigate={onNavigate} LanguageSelection={LanguageSelection} />
    </div>
  );
}

function MobileMenuContent({ isOpen, onClose, onNavigate, LanguageSelection }) {
  const { t } = useI18n();

  return (
    <>
      <div
        className={`absolute inset-0 bg-black/80 transition-opacity duration-500 cursor-pointer ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />

      <div
        className={`relative w-[85%] max-w-[320px] bg-[#1a0505] h-full shadow-2xl flex flex-col border-r border-[#c32228]/20 transition-transform duration-500 ease-[cubic-bezier(0.7,0,0.3,1)] will-change-transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] pointer-events-none" />

        <div className="flex items-center justify-between p-6 border-b border-white/10 relative z-10">
          <button
            onClick={onClose}
            className="p-2 rounded-full bg-white/5 text-gray-400 hover:bg-[#c32228] hover:text-white transition-colors cursor-pointer"
          >
            <X size={24} />
          </button>

          <div className="flex items-center gap-2 text-white">
            <span className="text-xl font-serif font-bold">
              {t("nav.brandName")}<span className="text-[#c32228]">{t("nav.brandHighlight")}</span>
            </span>
            <div className="p-1.5 rounded-full border border-[#c32228]/50">
              <UtensilsCrossed size={16} className="text-[#c32228]" />
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col py-6 px-4 gap-2 overflow-y-auto relative z-10">
          {[
            { name: t("nav.home"), id: "home" },
            { name: t("nav.categories"), id: "categories" },
            { name: t("nav.products"), id: "products" },
          ].map((item, index) => (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={`flex items-center justify-between p-4 rounded-lg text-lg font-bold text-gray-300 hover:text-white hover:bg-white/5 transition-all duration-300 group ${
                isOpen ? "translate-x-0 opacity-100" : "-translate-x-4 opacity-0"
              }`}
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              <span>{item.name}</span>
              <ArrowLeft
                size={18}
                className="text-[#c32228] opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all"
              />
            </button>
          ))}

          {/* Language Switcher */}
          <div
            className="mt-8 border-t border-white/10 pt-8 opacity-0 animate-fade-in-up"
            style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
          >
            <div className="text-center text-gray-500 text-xs mb-3 font-bold tracking-widest uppercase">
              {t("mobileMenu.changeLang")}
            </div>
            <LanguageSelection isMobile={true} />
          </div>
        </div>
      </div>
    </>
  );
}
